import React from 'react';

import './styles.css';

function LinearLoader({ white = false }) {
    return <span className={`linear-loader ${white ? 'white' : ''}`}></span>
}

export default LinearLoader;